module.exports = __webpack_public_path__ + "img/pcap-config.7653cd69.png";